import React, { Component } from 'react'
import Formsy from 'formsy-react'
import delay from 'lib/delay'

import SensitiveInfoPopup from '../../../DashboardPopup/SensitiveInfoPopup/SensitiveInfoPopup'
import PasswordChangedPopup from '../../../DashboardPopup/PasswordChangedPopup/PasswordChangedPopup'
import GeneralErrorPopup from 'modules/dashboard/DashboardPopup/GeneralErrorPopup/GeneralErrorPopup'
import Loader from 'components/UI/Loader/Loader'
import IconButton from 'components/UI/Button/IconButton'
import YourDetailsColumn from './components/YourDetailsColumn/YourDetailsColumn'
import ClassDetailsColumn from './components/ClassDetailsColumn/ClassDetailsColumn'

import {
  Content,
  ButtonColumn,
  MobileButtons,
  DeleteAccountMessage,
  StyledLink
} from './YourAccount.styles'
import { phoneMaxWidth, LoaderWrapper, GradientWrapper } from '../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class YourAccount extends Component {
  constructor (props) {
    super(props)

    this.state = {
      initialState: {},
      teacherDetails: {},
      classDetails: {},
      isEditMode: false,
      battleControlCustomUnlock: false
    }

    this.setTeacherState = this.setTeacherState.bind(this)
    this.setClassState = this.setClassState.bind(this)
    this.setBattleControlUnlock = this.setBattleControlUnlock.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  static defaultProps = {
    modal: {
      open: () => {},
      close: () => {},
      closeAll: () => {}
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    // prevent state refresh after failed mutation (due to wrong password)
    const currentModalId = this.props.modal.getCurrent().id
    if (currentModalId === 'sensitiveInfoPopup' && this.state.teacherDetails._id) return

    const { teacherDetails, classDetails } = nextProps

    if (teacherDetails && classDetails) {
      this.setState({
        initialState: { teacherDetails, classDetails },
        teacherDetails,
        classDetails
      })
    }
  }

  setTeacherState ({ field, value }) {
    this.setState({
      teacherDetails: {
        ...this.state.teacherDetails,
        [field]: value
      }
    })
  }

  setClassState ({ field, value }) {
    this.setState({
      classDetails: {
        ...this.state.classDetails,
        [field]: value
      }
    })
  }

  onKeyPress (event) {
    if (event.target.type !== 'textarea' && event.which === 13 /* Enter */) {
      event.preventDefault()
    }
  }

  setBattleControlUnlock () {
    this.setState({
      classDetails: { ...this.state.classDetails, battleLockedUntil: '1970-01-01T00:00:00.000Z' },
      battleControlCustomUnlock: true
    })
  }

  async onSubmit () {
    const { teacherDetails, classDetails, classBlogImage } = this.state

    const newTeacherDetails = Object.keys(this.state.teacherDetails)
      .reduce((acc, el) => {
        if (this.state.teacherDetails[el] !== this.state.initialState.teacherDetails[el]) {
          return { ...acc, [el]: this.state.teacherDetails[el] }
        }
        return acc
      }, {})

    if (newTeacherDetails.password || newTeacherDetails.email) {
      return this.openSensitiveInfoModal(newTeacherDetails, classDetails)
    }
    try {
      if (Object.keys(newTeacherDetails).length) {
        await this.props.updateTeacherDetails(newTeacherDetails)
      }
      await this.updateClassDetails(classDetails)
      this.setState({ isEditMode: false })
      await delay(1000)
      await this.refetchData()
    } catch (e) {
      this.props.modal.forceOpen(<GeneralErrorPopup isSettings />)
    }
  }

  openSensitiveInfoModal (teacherDetails, classDetails) {
    const modal = this.props.modal

    modal.open(
      <SensitiveInfoPopup
        isChangingPassword={!!teacherDetails.password}
        onConfirm={async ({ password }) => {
          try {
            await this.props.updateTeacherDetails(teacherDetails, password)
            await this.updateClassDetails(classDetails)

            if (teacherDetails.password) modal.forceOpen(<PasswordChangedPopup />)
            else modal.close()

            this.setState({ isEditMode: false })
            await delay(1000)
            await this.refetchData()
          } catch (e) {
            if (e.graphQLErrors && e.graphQLErrors[0].message === 'Access Denied') {
              return modal.updateProps({
                passwordError: true
              })
            }
            modal.forceOpen(<GeneralErrorPopup isSettings />)
          }
        }}
        onCancel={() => modal.close()}
      />,
      'sensitiveInfoPopup'
    )
  }

  async updateClassDetails (classDetails) {
    await this.props.updateClassDetails({
      _id: classDetails._id,
      name: classDetails.name,
      yearGroup: classDetails.yearGroup,
      description: classDetails.description,
      headerArtwork: {
        url: classDetails.headerArtwork
      },
      battleLockedUntil: classDetails.battleLockedUntil
    })
  }

  async refetchData () {
    const { data } = await this.props.client.query({
      query: this.props.queries[0].query,
      fetchPolicy: 'network-only'
    })

    const me = data.me
    const group = data.me.group

    const teacherDetails = {
      name: me.name,
      email: me.email,
      twitter: me.twitter,
      skype: me.skype
    }

    const classDetails = {
      _id: group._id,
      yearGroup: group.yearGroup,
      name: group.name,
      description: group.description,
      headerArtwork: group.headerArtwork && group.headerArtwork.url,
      battleLockedUntil: group.battleLockedUntil
    }

    this.setState({
      initialState: { teacherDetails, classDetails },
      teacherDetails,
      classDetails,
      battleControlCustomUnlock: false
    })
  }

  renderDesktopButtons () {
    return (
      <ButtonColumn>
        {this.state.isEditMode
          ? <React.Fragment>
            <IconButton
              bgColor={colors.lightBlue}
              color='white'
              iconName='cross'
              size='regular'
              onClick={() => this.setState({
                ...this.state.initialState,
                isEditMode: false,
                battleControlCustomUnlock: false
              })}
            >
                Undo
            </IconButton>
            <IconButton
              data-save
              element='button'
              type='submit'
              form='your-account'
              bgColor={colors.grassGreen}
              color='white'
              iconName='check'
              size='regular'
              columnView
            >
                Save
            </IconButton>
          </React.Fragment>
          : <IconButton
            bgColor={colors.orange}
            iconName='pencil'
            color='white'
            size='regular'
            columnView
            onClick={() => this.setState({
              isEditMode: true
            })}
          >
              Edit
          </IconButton>
        }
      </ButtonColumn>
    )
  }

  renderMobileButtons () {
    return (
      <MobileButtons>
        {this.state.isEditMode
          ? <IconButton
            data-save
            element='button'
            type='submit'
            form='your-account'
            bgColor={colors.grassGreen}
            color='white'
            iconName='check'
            size='regular'
            columnView
          >
              Save
          </IconButton>
          : <IconButton
            bgColor={colors.orange}
            iconName='pencil'
            color='white'
            size='regular'
            columnView
            onClick={() => this.setState({
              isEditMode: true
            })}
          >
              Edit
          </IconButton>
        }
      </MobileButtons>
    )
  }

  render () {
    if (this.props.loading) {
      return (
        <LoaderWrapper>
          <Loader bgColor='rgba(0,0,0,0)' itemColor={colors.pink} itemSize='90' />
        </LoaderWrapper>
      )
    }

    return (
      <Formsy id='your-account' onKeyPress={this.onKeyPress} onValidSubmit={this.onSubmit}>
        <GradientWrapper>
          <Content>
            <YourDetailsColumn
              isEditMode={this.state.isEditMode}
              setEditMode={(bool) => this.setState({ isEditMode: bool })}
              teacherDetails={this.state.teacherDetails}
              setTeacherState={this.setTeacherState}
              loading={this.props.loading}
              screenWidth={this.props.screenWidth}
            />
            <ClassDetailsColumn
              isParent={this.props.isParent}
              isEditMode={this.state.isEditMode}
              setEditMode={(bool) => this.setState({ isEditMode: bool })}
              classDetails={this.state.classDetails}
              initialClassDetails={this.state.initialState.classDetails}
              setClassState={this.setClassState}
              battleControlCustomUnlock={this.state.battleControlCustomUnlock}
              setBattleControlUnlock={this.setBattleControlUnlock}
              loading={this.props.loading}
              modal={this.props.modal}
            />
            {this.props.screenWidth > phoneMaxWidth
              ? this.renderDesktopButtons()
              : this.renderMobileButtons()
            }
          </Content>
          <DeleteAccountMessage>
            We are committed to maintaining your privacy. To delete your account completely, please email
            <StyledLink href='mailto:support@nightzookeeper.com'> support@nightzookeeper.com</StyledLink>.
          </DeleteAccountMessage>
        </GradientWrapper>
      </Formsy>
    )
  }
}
